export const getters = {
  resource: (state) => (key) => {
    let resource = state.resources[key];

    if (resource) {
      return resource;
    }
    return "The resource key requested don't exist or not loaded when is mounted the component";
  },
  currentAcademicYear: (state) => {
    if (state.currentAcademicYear) {
      return state.currentAcademicYear;
    } else {
      return 'The current academic year is not available';
    }
  },
};
